import "./Toggle.scss";

type ToggleProps = {
  isEnabled: boolean;
  onToggle: (value: boolean) => void;
  disabled?: boolean;
};

export const Toggle = ({
  isEnabled,
  onToggle,
  disabled = false,
}: ToggleProps) => {
  return (
    <button
      className={`toggle ${isEnabled ? "toggle--enabled" : ""} ${
        disabled ? "toggle--disabled" : ""
      }`}
      onClick={() => !disabled && onToggle(!isEnabled)}
      type="button"
      role="switch"
      aria-checked={isEnabled}
      disabled={disabled}
    >
      <span className="toggle__dot" />
    </button>
  );
};
